import AchievementsBlock from './achievement/AchievementsBlock';
import BottomEmissionsRateBlock from './bottom-emissions-rate/BottomEmissionsRateBlock';
import CO2EmissionsBlock from './co2-emissions/CO2EmissionsBlock';
import './ExportPageComponent.scss';
import { MAX_ELEMENTS_PER_LIST } from './functions';
import RecycledRecoveredBlock from './recycled-recovered/RecycledRecoveredBlock';
import TopRecyclingRateBlock from './top-recycling-rate/TopRecyclingRateBlock';
import TopReducedWasteRateBlock from './top-reduced-waste-rate/TopReducedWasteRateBlock';
import WasteTypePercentageBlock from './waste-type-percentage/WasteTypePercentageBlock';
import WasteTypePeriodBlock from './waste-type-period/WasteTypePeriodBlock';
import WasteTypeSiteAdditionalBlock from './waste-type-site-additional/WasteTypeSiteAdditionalBlock';
import WasteTypeSiteBlock from './waste-type-site/WasteTypeSiteBlock';

interface ExportPageComponentProps {
  filterDateStart?: Date;
  filterDateEnd?: Date;
  filterSiteList: any[];
  filterWasteTypeList: any[];
  achievementDataArray: any[];
  recycledWasteTypes: any[];
  recycledWasteDetails: any[];
  wasteTypePeriodGraphData: any[];
  wasteTypePeriodTableData: any[];
  wasteTypePeriodLegendData: any[];
  wasteTypeSiteGraphData: any[];
  wasteTypeSiteTableData: any[];
  wasteTypeSiteLegendData: any[];
  recycledRecoveredGraphData: any[];
  recycledRecoveredTableData: any[];
  recycledRecoveredLegendData: any[];
  co2EmissionsGenerated: any[];
  leaderboardRRTopGraph: any[];
  leaderboardRRTopTable: any[];
  leaderboardERTopGraph: any[];
  leaderboardERTopTable: any[];
  leaderboardRWRTopGraph: any[];
  leaderboardRWRTopTable: any[];
};

const ExportPageComponent = (props: ExportPageComponentProps) => {
  const startDateString = props.filterDateStart ?
    props.filterDateStart.toLocaleDateString() : (new Date()).toLocaleDateString();
  const endDateString = props.filterDateEnd ?
    props.filterDateEnd.toLocaleDateString() : (new Date()).toLocaleDateString();
  let siteList = props.filterSiteList && props.filterSiteList.length > 0 ? '' : 'All sites';
  props.filterSiteList?.filter((_, idx) => idx < MAX_ELEMENTS_PER_LIST).forEach((elem, idx) => {
    if (idx + 1 === props.filterSiteList.length) siteList += elem.label;
    else siteList += elem.label + ', ';
  });
  if (props.filterSiteList && props.filterSiteList.length > MAX_ELEMENTS_PER_LIST) {
    siteList += '...';
  }
  let wasteTypeList = props.filterWasteTypeList && props.filterWasteTypeList.length > 0 ?
    '' : 'All waste types';
  props.filterWasteTypeList?.filter((_, idx) => idx < MAX_ELEMENTS_PER_LIST).forEach((elem, idx) => {
    if (idx + 1 === props.filterWasteTypeList.length) wasteTypeList += elem.label;
    else wasteTypeList += elem.label + ', ';
  });
  if (props.filterWasteTypeList && props.filterWasteTypeList.length > MAX_ELEMENTS_PER_LIST) {
    wasteTypeList += '...';
  }

  const wtSiteBlockAdditionalPages = Math.floor(props.wasteTypeSiteGraphData.length / 16);

  return (
    <>
      <div id='export-page-content-1' className='export-page-container'>
        <div className="block-title">FILTERS</div>
        <div className="block-content">
          <p><b>Period:</b>{' ' + startDateString + ' - ' + endDateString}</p>
          <p><b>Site(s):</b> {siteList}</p>
          <p><b>Waste Type(s):</b> {wasteTypeList}</p>
        </div>
        <div className='block-title'>KPIs</div>
        <div className='block-content'>
          <AchievementsBlock achievementDataArray={props.achievementDataArray} />
        </div>
      </div>
      <div id='export-page-content-2' className='export-page-container'>
        <div className='block-title'>Waste Type By Percentage, t</div>
        <div className='block-content'>
          <WasteTypePercentageBlock
            graphData={props.recycledWasteTypes}
            tableData={props.recycledWasteDetails}
          />
        </div>
      </div>
      <div id='export-page-content-3' className='export-page-container'>
        <div className='block-title'>Waste Type By Period, t</div>
        <WasteTypePeriodBlock
          graphData={props.wasteTypePeriodGraphData}
          tableData={props.wasteTypePeriodTableData}
          typeArray={props.wasteTypePeriodLegendData}
        />
      </div>
      <div id='export-page-content-4' className='export-page-container'>
        <div className='block-title'>Top Sites By Waste Type, t</div>
        <WasteTypeSiteBlock
          graphData={props.wasteTypeSiteGraphData}
          tableData={props.wasteTypeSiteTableData}
          typeArray={props.wasteTypeSiteLegendData}
        />
      </div>
      {Array.from({ length: wtSiteBlockAdditionalPages }).map((_, index) => (
        <div key={index} id={`export-page-content-${4 + (index + 1)}`} className='export-page-container'>
          <div className='block-title'>Top Sites By Waste Type, t</div>
          <WasteTypeSiteAdditionalBlock
            graphData={props.wasteTypeSiteGraphData.slice((index + 1) * 16, (index + 2) * 16)}
            typeArray={props.wasteTypeSiteLegendData}
          />
        </div>
      ))}
      <div id={`export-page-content-${5 + wtSiteBlockAdditionalPages}`} className='export-page-container'>
        <div className='block-title'>Total Waste Recycled and Recovered, t</div>
        <RecycledRecoveredBlock
          graphData={props.recycledRecoveredGraphData}
          tableData={props.recycledRecoveredTableData}
          typeArray={props.recycledRecoveredLegendData}
        />
      </div>
      <div id={`export-page-content-${6 + wtSiteBlockAdditionalPages}`} className='export-page-container'>
        <div className='block-title'>CO2 Emissions Generated, t</div>
        <CO2EmissionsBlock data={props.co2EmissionsGenerated} />
      </div>
      <div id={`export-page-content-${7 + wtSiteBlockAdditionalPages}`} className='export-page-container'>
        <div className='block-title'>Leaderboard - TOP 5 Sites by Recycling Rate %</div>
        <TopRecyclingRateBlock
          graphData={props.leaderboardRRTopGraph}
          tableData={props.leaderboardRRTopTable}
        />
      </div>
      <div id={`export-page-content-${8 + wtSiteBlockAdditionalPages}`} className='export-page-container'>
        <div className='block-title'>Leaderboard - TOP 5 Sites by Emissions Rate %</div>
        <BottomEmissionsRateBlock
          graphData={props.leaderboardERTopGraph}
          tableData={props.leaderboardERTopTable}
        />
      </div>
      <div id={`export-page-content-${9 + wtSiteBlockAdditionalPages}`} className='export-page-container'>
        <div className='block-title'>Leaderboard - TOP 5 Sites by Reduced Waste Rate %</div>
        <TopReducedWasteRateBlock
          graphData={props.leaderboardRWRTopGraph}
          tableData={props.leaderboardRWRTopTable}
        />
      </div>
    </>
  );
};

export default ExportPageComponent;